import { render, staticRenderFns } from "./PagePayment.vue?vue&type=template&id=4758c572&scoped=true&"
import script from "./PagePayment.vue?vue&type=script&lang=js&"
export * from "./PagePayment.vue?vue&type=script&lang=js&"
import style0 from "./PagePayment.vue?vue&type=style&index=0&id=4758c572&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4758c572",
  null
  
)

export default component.exports